
import { AnagraficaService } from './anagrafica.service';
import { SpecializzazioneService } from './specializzazione.service';

export default () => {
  return addServices([
    { 'AnagraficaService': AnagraficaService },
    { 'SpecializzazioneService': SpecializzazioneService }
  ])
}

const addServices = (services: any[]) => {
  const obj = {};
  services.forEach(service => {
    const k = Object.keys(service)[0];
    const v = service[k];
    Object.defineProperty(obj, k, {
      enumerable: true,
      get: () => { return new v() },
    })
  })
  return obj;
}